var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.getDropZoneOptions()},on:{"vdropzone-success":_vm.uploadDone}})}
var staticRenderFns = []

export { render, staticRenderFns }